import React, { useState, useMemo } from 'react';
import moment from "moment";

const VouchersTable = ({ vouchers, tabelTitle }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const isSuccessTable = tabelTitle.toLowerCase().includes('success');

    const filteredVouchers = useMemo(() => {
        // if (!searchTerm.trim()) return vouchers;
        const lowerSearch = searchTerm.toLowerCase().trim();
        return vouchers.filter((voucher) => {
            return (
                voucher.verification_code?.toLowerCase().includes(lowerSearch) ||
                voucher.email?.toLowerCase().includes(lowerSearch)
            );
        });
    }, [vouchers, searchTerm]);

    if (!vouchers || vouchers.length === 0) return null;

    return (
        <div>
            <div className="failed-vouchers-container">

                {/* Search Input */}
                <div className='search-wrapper'>
                <h2>{tabelTitle}</h2>
                    <input
                        type="text"
                        placeholder="Search by email or verification code..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            padding: '8px',
                            width: '100%',
                            maxWidth: '400px',
                            borderRadius: '4px',
                            border: '1px solid #ccc'
                        }}
                    />
                </div>

                {/* Table */}
                <table className="failed-vouchers-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Verification Code</th>
                            <th>Email</th>
                            {isSuccessTable ? (
                                <>
                                    <th>Used At</th>
                                    <th>Redeem</th>
                                </>
                            ) : (
                                <th>Error</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredVouchers.length > 0 ? (
                            filteredVouchers.map((voucher, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{voucher.verification_code}</td>
                                    <td>{voucher.email}</td>
                                    {isSuccessTable ? (
                                        <>
                                            <td>{voucher.used_at ? moment(voucher.used_at).format('D MMM YYYY, hh:mm A') : '-'}</td>
                                            <td>{voucher.used_at ? 'Yes' : 'No'}</td>
                                        </>
                                    ) : (
                                        <td>{voucher.error}</td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={isSuccessTable ? 5 : 4}>No matching records found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="totalDiv">Total: {filteredVouchers.length}</div>
        </div>
    );
};

export default VouchersTable;
